export const workspacesKeys = {
  all: [{ module: 'workspaces' }] as const,
  lists: () => [{ ...workspacesKeys.all[0], scope: 'list' }] as const,
  listsByOrganization: (organizationId: string) => [{ ...workspacesKeys.lists()[0], organizationId }] as const,
  details: () => [{ ...workspacesKeys.all[0], scope: 'detail' }] as const,
  detailBySlugs: (orgSlug: string, wsSlug: string) => [{ ...workspacesKeys.details()[0], orgSlug, wsSlug }] as const,
  teams: () => [{ ...workspacesKeys.all[0], scope: 'teams' }] as const,
  teamsBySlugs: (orgSlug: string, wsSlug: string) => [{ ...workspacesKeys.teams()[0], orgSlug, wsSlug }] as const,
  slugAvailabilities: () => [{ ...workspacesKeys.all[0], scope: 'slugAvailability' }] as const,
  slugAvailability: (organizationId: string, wsSlug: string) =>
    [{ ...workspacesKeys.slugAvailabilities()[0], organizationId, wsSlug }] as const,
  availableTeams: () => [{ ...workspacesKeys.all[0], scope: 'availableTeams' }] as const,
  availableTeamsBySlugs: (orgSlug: string, wsSlug: string) =>
    [{ ...workspacesKeys.availableTeams()[0], orgSlug, wsSlug }] as const,
};
